import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { userProfileService } from "../../api/services/userProfileService";
import Loader from "../Loader/Loader";
import "./ForgotPassword.css";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState("success");

  const closeModal = () => {
    setModalMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setModalMessage("");
    setLoading(true);

    try {
      const res = await userProfileService.forgetPassword(email.trim());
      const ok =
        Number(res?.success) === 1 ||
        res?.success === true ||
        res?.success === "1";
      if (ok) {
        setEmail("");
        navigate("/", { replace: true });
        return;
      } else {
        setModalType("error");
        setModalMessage(
          res?.msg ??
            res?.message ??
            "Unable to send reset email. Please try again.",
        );
      }
    } catch (err) {
      console.error("Forgot password request:", err);
      setModalType("error");
      setModalMessage(
        err?.response?.data?.msg ??
          err?.response?.data?.message ??
          err?.message ??
          "Unable to send reset email. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-page">
      {loading && <Loader />}
      {modalMessage && (
        <div
          className="fp-result-popup"
          role="dialog"
          aria-modal="true"
          aria-labelledby="fp-result-popup-title"
          onClick={closeModal}
        >
          <div
            className={`fp-result-popup-content fp-result-popup-content--${modalType}`}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="fp-result-popup-close"
              onClick={closeModal}
              aria-label="Close"
            >
              ×
            </button>
            <p
              id="fp-result-popup-title"
              className="fp-result-popup-message"
            >
              {modalMessage}
            </p>
          </div>
        </div>
      )}

      <div className="forgot-password-container">
        <div className="forgot-password-content">
          <h1 className="forgot-password-title">Forgot your password?</h1>
          <p className="forgot-password-line">
            We will send a secure password reset link to your email address.
          </p>

          <form className="forgot-password-form" onSubmit={handleSubmit}>
            <div className="forgot-password-field">
              <label htmlFor="forgot-email" className="forgot-password-label">
                Email address
              </label>
              <input
                id="forgot-email"
                name="email"
                type="email"
                autoComplete="email"
                className="forgot-password-input"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
              />
            </div>

            <button
              type="submit"
              className="forgot-password-submit"
              disabled={loading}
            >
              {loading ? "Sending…" : "Send reset email"}
            </button>
          </form>

          <p className="forgot-password-back">
            <Link to="/login">Back to sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
